import React, { useEffect, useMemo, useState } from "react";
import { Document, Page } from "react-pdf";
import { useLocation, useParams } from "react-router-dom";
import { useStores } from "../../use.store";
import { observer } from "mobx-react-lite";
import { getInformationAsset } from "../../helper";
import ImageLoader from "../../components/ImageLoader";
import VideoPlayer from "../../components/Video";

const FilePage = observer(() => {
  //   const { contentName } = useParams();
  const { mapStore } = useStores();
  const location = useLocation();

  const [contentName, setcontentName] = useState();
  const [content, setContent] = useState();
  const [contentType, setContentType] = useState();

  const [numPages, setNumPages] = useState(null);
  const opt = useMemo(() => {
    return {
      cMapUrl: "/bcmaps/",
      cMapPacked: true,
    };
  }, []);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const name = params.get("name");
    setcontentName(name);
  }, []);

  useEffect(() => {
    if (
      mapStore &&
      mapStore.medias &&
      mapStore.medias.length > 0 &&
      contentName
    ) {
      const selectedData = mapStore.information
        .filter((data) => {
          return data.name
            .replace(/[^a-zA-Z0-9]/g, "")
            .toLowerCase()
            .includes(contentName.replace(/[^a-zA-Z0-9]/g, "").toLowerCase());
        })
        .sort((a, b) => a.name.localeCompare(b.name));
      if (selectedData) {
        setContentType(selectedData?.[0]?.files?.[0]?.fileType);
        setContent(getInformationAsset(selectedData?.[0]?.files?.[0]?.logo));
      }
    }
  }, [mapStore, mapStore.medias, contentName]);

  return (
    <>
      {contentType === "application/pdf" ? (
        <div className="w-full h-full">
          <div className="flex md:hidden flex-col gap-y-4 md:gap-x-4 mt-8">
            {content && (
              <Document
                file={content}
                options={opt}
                onLoadSuccess={onDocumentLoadSuccess}
                className="flex flex-col items-center"
                loading={<div className="loader"></div>}
                error={<p>Error loading PDF</p>}
              >
                {numPages &&
                  Array.from(new Array(numPages), (el, index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      renderTextLayer={false}
                      renderAnnotationLayer={false}
                      width={window.innerWidth}
                    />
                  ))}
              </Document>
            )}
          </div>
          <div className="hidden md:flex flex-col gap-y-4 md:gap-x-4 mt-4">
            {content && (
              <Document
                file={content}
                options={opt}
                onLoadSuccess={onDocumentLoadSuccess}
                className="flex flex-col w-full items-center"
                loading={<div className="loader"></div>}
                error={<p>Error loading PDF</p>}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))}
              </Document>
            )}
          </div>
        </div>
      ) : contentType === "image/png" ||
        contentType === "image/jpeg" ||
        contentType === "image/jpg" ? (
        <ImageLoader src={content} className="w-full h-full" />
      ) : contentType === "video/mp4" ? (
        <VideoPlayer src={content} />
      ) : (
        <></>
      )}
    </>
  );
});

export default FilePage;
